"use client"

import QueryProvider from './QueryProvider'
import BuildVersionGuard from './BuildVersionGuard'

interface AppProvidersProps {
  children: React.ReactNode
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <BuildVersionGuard />
      {children}
    </QueryProvider>
  )
}
